import './alfabutton.styles.scss';
import {RedirectAlfaService} from "../../../../services/redirectalfa.service";
import AlfaIcon from './../images/logo Alfa (White). 24px.svg';


const AlfaButton = () => {
    const onClickHandler = () => {
        new RedirectAlfaService().redirect()
            .then(a => {
                if (!a || (a && !a.redirect_url)) {
                    alert('Упс.. Что-то пошло не так!');
                    return;
                }
                window.open(a.redirect_url, '_self');
            })
            .catch(e => {
                console.log(e);
                alert('Упс.. Что-то пошло не так!');
            });
    }

    return <div className="alfa_button__container">
        <button
            type="button"
            onClick={onClickHandler}
        >
            <img
                src={AlfaIcon}
                alt='Alfa Icon'
            />
            Альфа ID
        </button>
    </div>;
}

export default AlfaButton;
